import { render, staticRenderFns } from "./ToggleFullscreen.vue?vue&type=template&id=2c713ca1&scoped=true&lang=pug&"
import script from "./ToggleFullscreen.vue?vue&type=script&lang=js&"
export * from "./ToggleFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./ToggleFullscreen.vue?vue&type=style&index=0&id=2c713ca1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c713ca1",
  null
  
)

export default component.exports